'use strict';

app.controller('NotificationCtrl', [
    '$rootScope',
    '$scope',
    '$http',
    '$timeout',
    function($rootScope, $scope, $http, $timeout) {
        var NOTIFICATION_READED = 'readed';
        var NOTIFICATION_DELETED = 'deleted';

        var REFRESH_TIME_IN_MILISECONDS = 300000;

        var loading = false;
        $scope.loadTimeout = null;

        $scope.more = {
            on: true,
            initial: true,
            time: new moment(),
            load: loadMore,
        };
        $scope.more.time.startOf('day').subtract(1, 'day');

        $scope.notifications = {
            results: [],
            counts: {
                all: 0,
                unreaded: 0,
            },
        };

        function loadMore() {
            $scope.more.on = false;
            $scope.more.time.subtract(1, 'day');

            return $scope.getNotifications().then(
                function() {
                    $scope.more.on = true;
                },
                function() {
                    $scope.more.on = true;
                }
            );
        }

        $scope.isReaded = function(notification) {
            return notification.status === NOTIFICATION_READED;
        };

        $scope.isDeleted = function(notification) {
            return notification.status === NOTIFICATION_DELETED;
        };

        $scope.getLocalDateTime = function(date) {
            var m = moment(date);

            return m.format('YYYY-MM-DD HH:mm');
        };

        $scope.reloadNotificationCounter = function() {
            $rootScope.$broadcast('reloadNotificationCounter', {
                counts: $scope.notifications.counts,
            });
        };

        $scope.getNotifications = function() {
            $scope.more.on = false;

            var params = {
                timestamp: $scope.more.time.unix(),
                initial: $scope.more.initial,
            };

            var endpoint = '/rest-api/ms/notification/api/notification';

            return $http.get(endpoint, { params: params, displayButterbar: false }).then(
                function(response) {
                    $scope.more.on = true;

                    var data = response.data;

                    if (response.data === void 0) {
                        return false;
                    }

                    $scope.notifications = data;
                    $scope.more.initial = false;

                    $scope.reloadNotificationCounter();
                    $scope.closePanelWhenEmpty();

                    $timeout.cancel($scope.loadTimeout);
                    $scope.loadTimeout = $timeout($scope.getNotifications, REFRESH_TIME_IN_MILISECONDS);
                },
                function() {
                    $scope.more.on = true;
                }
            );
        };

        $scope.readAll = function() {
            if (loading) {
                return false;
            }

            loading = true;

            var endpoint = '/rest-api/ms/notification/api/notification/read';

            return $http
                .post(endpoint)
                .then(
                    function() {
                        loading = false;
                    },
                    function() {
                        loading = false;
                    }
                )
                .then(function() {
                    $scope.getNotifications();
                });
        };

        $scope.update = function(notification) {
            if (loading) {
                return false;
            }

            loading = true;

            var id = notification.id;
            var endpoint = `/rest-api/ms/notification/api/notification/${id}/flag`;

            $http.put(endpoint, {}, { displayButterbar: false }).then(
                function(response) {
                    var data = response.data;

                    notification.status = data.status;

                    switch (notification.status) {
                        case NOTIFICATION_READED:
                            $scope.notifications.counts.unreaded--;
                            break;
                        case NOTIFICATION_DELETED:
                            $scope.notifications.counts.all--;
                            break;
                    }

                    $scope.reloadNotificationCounter();
                    $scope.closePanelWhenEmpty();

                    loading = false;
                },
                function() {
                    loading = false;
                }
            );
        };

        $scope.closePanelWhenEmpty = function() {
            if ($scope.notifications.counts.all === 0) {
                var $panel = $('.cd-panel.cd-panel--is-visible');
                if ($panel.length) {
                    $panel.removeClass('cd-panel--is-visible');
                }
            }
        };

        $scope.$on('$destroy', function() {
            $timeout.cancel($scope.loadTimeout);
        });

        $scope.init = function() {
            $scope.getNotifications();
        };
        $scope.init();
    },
]);
